import BaseController from "confinus_ui/base_controller";
import { closeModal } from "lib/overlay/modal";

export default class ModalCloseButtonController extends BaseController {
  public static values = {
    closeReason: { type: String, default: null },
  };

  declare private readonly closeReasonValue: any;
  public handleButtonClick(event: Event) {
    event.preventDefault();
    const reason = this.closeReasonValue;
    closeModal({
      closeReason: reason ? reason : undefined,
    });
  }
}
